import React, { CSSProperties } from "react";

interface TableLinkProps {
    onClick: () => void;
    children: React.ReactNode;
    className?: string;
    style?: CSSProperties;
}

const BASE_STYLE: CSSProperties = {
    display: "block",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "var(--bs-table-link-color)",
    cursor: "pointer",
};

const TableLink = ({ onClick, children, className, style }: TableLinkProps) => (
    <a
        className={className}
        style={style ? { ...BASE_STYLE, ...style } : BASE_STYLE}
        onClick={onClick}
    >
        {children}
    </a>
);

export default TableLink;
